import React, { useContext } from 'react';

export const queryParamsContext = React.createContext({});

export const useQueryParamsContext = () => useContext(queryParamsContext);
